import React, { Component } from "react";
import Tooltip from "./Tooltip";

class ToggleSwitch extends Component {
	constructor(props) {
		super(props);
		this.state = { timestamp: null };

		this.onChange = this.onChange.bind(this);
	}

	onChange() {
		const { handleChange } = this.props;
		handleChange();
	}

	render() {
		const { timestamp } = this.state;
		const { value, offText, onText } = this.props;

		const msg =
			"Ops! Opção de ida e volta ainda não disponível. Em breve, mais esta novidade pra você ;)";

		return (
			<div className="toggle-switch">
				<span className={`toggle-switch__text${!value ? " active" : ""}`}>{offText}</span>
				<label className="toggle-switch__input">
					<input type="checkbox" checked={value} onChange={this.onChange} />
					<span className="toggle-switch__track" />
				</label>
				<span className={`toggle-switch__text${value ? " active" : ""}`}>{onText}</span>
			</div>
		);
	}
}

export default ToggleSwitch;
